import styled from 'styled-components';

import { visuallyHidden } from '@rewardopl/react-ui/visually_hidden/index.styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--gap);
`;

export const Image = styled.img`
  width: 128px;
  height: 128px;
`;

export const Description = styled.p`
  margin: 0;
  font-size: 18px;
`;

export const Question = styled.p`
  margin: 0;
  margin-top: -8px;
`;

export const Form = styled.form`
  display: contents;
`;

export const ThumbsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--gap);
`;

export const Input = styled.input`
  ${visuallyHidden}
`;

export const Label = styled.label`
  img,
  svg {
    transition: all ease-in-out 200ms;
  }

  ${Input}:checked + & {
    img,
    svg {
      scale: 1.2;
    }
  }
`;

export const Text = styled.span`
  ${visuallyHidden}
`;
